import { useCallback, useState, useEffect } from 'react';

import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { createContainer, useContainer } from 'unstated-next';

import { GET_USER_DATA } from '../../../../../config/apiPaths';
import { getUrlParams, getUrls, processApiPath } from '../../../../../utils/url';
import AdminAuthContainer from '../../../AdminAuthContainer';

interface PlannerContainerState {
    plannerData?: Record<string, any>; // result of the GET_CLASS_DATA_PATH api call
}

type LoadingStatus = 'INITIAL' | 'LOADING' | 'SUCCESS' | 'ERROR';

const usePlannerContainer = (state: PlannerContainerState = {}) => {
    console.log('PlannerContainer');
    const { api } = getUrls();

    const [plannerData, setPlannerData] = useState<any>();

    const { t: tCommon } = useTranslation('common');

    const { authMode } = useContainer(AdminAuthContainer);

    const search = new URLSearchParams(window.location.search);
    const plannerUuid = search.get('planner_uuid') || window.localStorage.getItem('planner_uuid');

    const [getPlannerStatus, setGetPlannerStatus] = useState<LoadingStatus>('INITIAL');
    const [errorMessage, setErrorMessage] = useState<string>('');

    const { plannerId: plannerIdV1 } = useParams<{ plannerId?: string }>();
    const { planner_id: plannerIdV2 } = getUrlParams();
    const plannerId = plannerIdV1 || plannerIdV2 || '';

    const returnErrorMessage = useCallback(
        (error: any): string => {
            console.error(error);
            return tCommon('errorMessage');
        },
        [tCommon]
    );

    const getPlannerDataCall = useCallback(async () => {
        const { data } = await axios.get(
            processApiPath(GET_USER_DATA, undefined, {
                planner_uuid: plannerUuid!,
                planner_id: plannerId,
                auth_mode: authMode
            })
        );

        if (data?.success === false) {
            throw Error(data?.error);
        }
        return data;
    }, [plannerUuid, plannerId, authMode]);

    const getPlanner = useCallback(async () => {
        setGetPlannerStatus('LOADING');

        try {
            const data = state.plannerData ?? (await getPlannerDataCall());

            setPlannerData(data);
            setGetPlannerStatus('SUCCESS');
        } catch (err) {
            const errorMsg = returnErrorMessage(err);
            setErrorMessage(errorMsg);
            setGetPlannerStatus('ERROR');
        }
    }, [state.plannerData, getPlannerDataCall, returnErrorMessage]);

    useEffect(() => {
        if (plannerId && plannerUuid) {
            getPlanner();
        }
    }, [plannerId, getPlanner, plannerUuid]);

    return {
        plannerId,
        api,
        plannerData,
        getPlannerStatus,
        errorMessage
    };
};

const PlannerContainer = createContainer(usePlannerContainer);

export default PlannerContainer;
